import { render, staticRenderFns } from "./foodCompanyDetails.vue?vue&type=template&id=14de60d1&scoped=true&lang=en&"
import script from "./foodCompanyDetails.vue?vue&type=script&lang=js&"
export * from "./foodCompanyDetails.vue?vue&type=script&lang=js&"
import style0 from "./foodCompanyDetails.vue?vue&type=style&index=0&id=14de60d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14de60d1",
  null
  
)

export default component.exports